import { createAppContainer, createSwitchNavigator } from 'react-navigation';
import { createStackNavigator } from 'react-navigation-stack';
import AuthScreen from '../screens/AuthScreen';
import HomeScreen from '../screens/HomeScreen';
import SignupScreen from '../screens/SignupScreen';
import ChangePasswordScreen from '../screens/ChangePasswordScreen';
import { Platform } from 'react-native';
import ResetPasswordScreen from '../screens/ResetPasswordScreen';
import AboutScreen from '../screens/AboutScreen';

const AuthNavigator = createStackNavigator({
    Login: AuthScreen,
    Signup: SignupScreen,
    Reset: ResetPasswordScreen
}, {
    defaultNavigationOptions: {
        cardStyle: {
            backgroundColor: 'white'
        },
        headerTintColor: Platform.OS === 'android' ? 'white' : '#404040',
        headerStyle: {
            backgroundColor: Platform.OS === 'android' ? '#404040' : 'white',
        }
    }
});

const HomeNavigator = createStackNavigator({
    Main: HomeScreen,
    ChangePassword: ChangePasswordScreen,
    About: AboutScreen
}, {
    defaultNavigationOptions: {
        cardStyle: {
            backgroundColor: 'white'
        },
        headerTintColor: Platform.OS === 'android' ? 'white' : '#404040',
        headerStyle: {
            backgroundColor: Platform.OS === 'android' ? '#404040' : 'white',
        }
    },
    initialRouteKey: 'Main',
    initialRouteName: 'Main'
});

const MainNavigator = createSwitchNavigator({
    Auth: AuthNavigator,
    Home: HomeNavigator
})

export default createAppContainer(MainNavigator);